import {Directive, forwardRef, Input} from '@angular/core';
import {FormControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
    providers: [{
            multi: true,
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => VermittlernummerValidator),
        }],
    selector: '[lvVermittlernummerValidator]',
    standalone: false
})
export class VermittlernummerValidator implements Validator {
  public validate(control: FormControl): ValidationErrors | null {
    if (!control || (!control.value && control.value !== 0) || control.value.length === 0) {
      return null;
    }
    return this._checkNumber(control);
  }

  private _checkNumber(control: FormControl): ValidationErrors | null {
    const numberToValidate = control.value.toString().trim();
    for (let i = 0; i < numberToValidate.length; i++) {
      if (isNaN(numberToValidate.charAt(i))) {
        return {ERROR: 'WRONG_NUMBER'};
      }
    }
    if (numberToValidate.length !== 6 && numberToValidate.length !== 8) {
      return {PARTIAL: 'LENGTH_NOT_6_OR_8'};
    }
    return null;
  }
}
